module.exports = "/_next/static/images/num-8-e80e2b4d.png";